// extracted by mini-css-extract-plugin
export default {"placeholder":"Avatar_placeholder__wVXF8","avatar":"Avatar_avatar__akmgH"};